import dom from '../utils/dom';
import OnePageGivingForm from './OnePageGivingForm';
import getCurrencyFormatter from '../tnew/currency/getCurrencyFormatter';
import createRecaptchaWrapper from './createRecaptchaWrapper';

/** @typedef {import("../tnew/lib/StateFilter").StateFilterConfig} StateFilterConfig */

/** @type {import("../tnew/lib/StateFilterRegistration").register} */
const StateFilterRegistrator = window.tnew.ui.stateFilter;

/**
 * @typedef OnePageGivingConfig
 * @property {boolean} isRecaptchaEnabled
 * @property {string} recaptchaSiteKey
 * @property {StateFilterConfig} stateFilterConfig
 */


/**
 * @param {OnePageGivingConfig} config
 */
const initForm = async (config) => {
  const currencyFormatter = await getCurrencyFormatter();

  const captcha = createRecaptchaWrapper(window.grecaptcha, config.isRecaptchaEnabled, config.recaptchaSiteKey);

  const $form = dom.find('.tn-opg-form');

  const form = new OnePageGivingForm($form, currencyFormatter, captcha);
};


/**
 * @param {OnePageGivingConfig} config
 */
window.tnew.page.initialize = (config) => {
  window.history.scrollRestoration = 'manual';
  window.addEventListener('unload', () => {});

  if (config.stateFilterConfig) {
    StateFilterRegistrator.register(config.stateFilterConfig);
  }

  initForm(config);
};




// WEBPACK FOOTER //
// ./src/onePageGiving/one-page-giving.js